// useAdminPayout — admin-only payout drill-down query.
//
// Gated at the call site by isAdminRole(useMe().role) and at the router
// by RequireAuth role="admin". The backend is the authoritative gate
// (RequireRole(admin) on /v1/admin/payouts/:id); these checks just
// avoid firing the 403 round-trip when the user clearly can't see this.
import { useQuery } from "@tanstack/react-query";

import { getAdminPayoutDetail, type AdminPayoutDetail } from "@/api/admin";

export function useAdminPayout(payoutId: number | null) {
  return useQuery<AdminPayoutDetail>({
    // queryKey scopes the cache by id so navigating between payouts
    // doesn't flash stale data. No merchant_id in the key — the admin
    // surface is cross-tenant by design.
    queryKey: ["admin-payout", payoutId],
    queryFn: () => getAdminPayoutDetail(payoutId!),
    enabled: payoutId != null && payoutId > 0,
    // No background refetch by default — payouts are mostly read-once
    // when an operator is triaging a failure. They can hit Refresh in
    // the page header to re-pull.
    staleTime: 30_000,
  });
}
